/**
 * Sinal Angular → React de que os módulos da conta (config_modulos) foram salvos.
 *
 * A sidebar React guarda o config_modulos em cache SWR por tenant e não revalida
 * sozinha; a tela de Integrações é uma folha Angular, que antes reconstruía o menu
 * legado em memória e não tem como tocar o cache do React. O módulo vive do lado
 * Angular para manter a dependência no sentido React → Angular, como as demais
 * pontes: o Angular só notifica, quem decide o que rebuscar é o React.
 */
type Listener = () => void;

const listeners = new Set<Listener>();

/** Avisa os inscritos de que o config_modulos do tenant ativo mudou no servidor. */
export function notifyConfigModulosChanged(): void {
  listeners.forEach((listener) => listener());
}

/** Inscreve um listener para alterações do config_modulos; retorna o cancelamento. */
export function subscribeConfigModulosChange(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
